import styled from '@emotion/styled';
import { colors, spacing, typography } from '../../../../../../../themes';

export const FileUploadStatusIconCloseWrapper = styled.div`
  display: flex;
  gap: ${spacing.xmsmall};
`;

export const FileUploadRowLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing.xxsmall};
`;

export const FileUploadRowLabel = styled.div`
  ${typography.body.large}
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: calc(100% - 150px);
`;

export const FileUploadRowDivider = styled.div`
  width: 100%;
  gap: ${spacing.xmsmall};
  height: 1px;
  background-color: ${colors.monochrome.grey30};
  margin: ${spacing.xmsmall} 0;
`;

export const FileListItem = styled.li`
  display: flex;
  flex-flow: column;
  width: 100%;
`;
